import { mString, pString } from 'lib/helpers/utility';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';
import ProgressBar from 'components/shared/ProgressBar/ProgressBar';

const BASIS_POINTS_PER_PERCENT = 100;

const toCssPercent = (basisPoints) =>
  Number.isFinite(basisPoints)
    ? Math.min(Math.max(basisPoints / BASIS_POINTS_PER_PERCENT, 0), 100)
    : 0;

const Segment = ({ basisPoints, color }) => (
  <div className="min-w-0" style={{ flex: `0 1 ${toCssPercent(basisPoints)}%` }}>
    <ProgressBar progress={100} stripeColor={color} progressColor={color} />
  </div>
);

const LegendItem = ({ label, amount, basisPoints, dot }) => (
  <div className="flex items-center gap-1.5">
    {dot}
    <Typography variant="label" className="block">
      {label}: <span className="font-medium">{mString(amount)}</span> ({pString(basisPoints)})
    </Typography>
  </div>
);

const CoverageBreakdown = ({
  isNothingDue,
  payments,
  paymentsBasisPoints,
  discounts,
  discountsBasisPoints,
  taxesAndFees,
  taxesBasisPoints,
  patientAmount,
  patientBasisPoints
}) => (
  <div className="flex flex-col gap-4 xs:hidden">
    <div className="flex w-full gap-1">
      {payments > 0 && <Segment basisPoints={paymentsBasisPoints} color="bg-purple-500" />}
      {discounts > 0 && <Segment basisPoints={discountsBasisPoints} color="bg-success-500" />}
      {taxesAndFees > 0 && <Segment basisPoints={taxesBasisPoints} color="bg-neutral-800" />}
      {!isNothingDue && <Segment basisPoints={patientBasisPoints} color="bg-primary-500" />}
    </div>
    <div className="flex flex-wrap justify-between gap-4 xs:flex-col">
      {payments > 0 && (
        <LegendItem
          label="Payments"
          amount={payments}
          basisPoints={paymentsBasisPoints}
          dot={<Dot size="sm" color="purple" />}
        />
      )}
      {discounts > 0 && (
        <LegendItem
          label="Discounts"
          amount={discounts}
          basisPoints={discountsBasisPoints}
          dot={<Dot size="sm" color="success" />}
        />
      )}
      {taxesAndFees > 0 && (
        <LegendItem
          label="Taxes and fees"
          amount={taxesAndFees}
          basisPoints={taxesBasisPoints}
          dot={<Dot size="sm" color="neutral" className="[&>div]:!bg-neutral-800" />}
        />
      )}
      {!isNothingDue && (
        <LegendItem
          label="You cover"
          amount={patientAmount}
          basisPoints={patientBasisPoints}
          dot={<Dot size="sm" color="primary" />}
        />
      )}
    </div>
  </div>
);

export default CoverageBreakdown;
